export const VERSION = "1.8.3";


// WEBPACK FOOTER //
// ./node_modules/axios/lib/env/data.js